import { AppError } from './AppError';

/**
 * Raised when a repository, storage, or other infrastructure boundary fails
 * (e.g. Supabase connection failure). Must always be caught and re-mapped
 * before reaching the UI — never shown to the end user directly.
 */
export class InfrastructureError extends AppError {
  constructor(code: string, message: string, options?: { cause?: unknown }) {
    super(code, message, options);
    this.name = 'InfrastructureError';
    Object.setPrototypeOf(this, InfrastructureError.prototype);
  }
}
